import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { SurveyService } from 'src/app/shared/services/survey.service';
@Component({
  selector: 'survey-introduction',
  templateUrl: './survey-introduction.component.html',
  styleUrls: ['./survey-introduction.component.scss'],
})
export class SurveyIntroductionComponent {
  private subscription: Subscription;
  @Input()
  inPreviewMode: boolean = false;
  @Output()
  previewSurveyStart = new EventEmitter();
  introduction: string;

  onStartSurveyClicked() {
    if (!this.inPreviewMode) {
      this.surveyService.startSurvey();
    } else {
      this.previewSurveyStart.emit();
    }
  }

  constructor(private surveyService: SurveyService) {}

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    if (!this.inPreviewMode) {
      this.subscription = this.surveyService.survey.subscribe((result) => {
        if (result) {
          this.introduction = result.introduction;
          this.surveyService.setSurveyForm();
        }
      });
    } else {
      this.subscription = this.surveyService.surveyPreview.subscribe((result) => {
        this.introduction = result.introduction;
      });
    }
  }
}
